import { defineLocale } from "../../registry";

const partners = defineLocale({
  ru: {
    "partners.add": "Добавить партнёра",
    "partners.empty": "Партнёров пока нет",
    "partners.col.name": "Название",
    "partners.col.type": "Тип",
    "partners.col.status": "Статус",
    "partners.col.brand": "Показ бренда",
    "partners.col.hosts": "Разрешённые хосты",
    "partners.col.actions": "Действия",
    "partners.edit": "Изменить",
    "partners.editNamed": "Изменить {name}",
    "partners.type.affiliate_network": "Партнёрская сеть",
    "partners.type.direct": "Прямой",
    "partners.type.editorial": "Редакционный",
    "partners.status.active": "Активен",
    "partners.status.disabled": "Отключён",
    "partners.brand.allowed": "Разрешён",
    "partners.brand.not_allowed": "Запрещён",
    "partners.value.unknown": "Неизвестно",
    "partners.hosts.none": "Нет",
    "partners.panel.title": "Данные партнёра",
    "partners.panel.new": "Новый партнёр",
    "partners.field.name": "Название",
    "partners.field.type": "Тип",
    "partners.field.status": "Статус",
    "partners.field.brand": "Показ бренда",
    "partners.field.hosts": "Разрешённые хосты",
    "partners.field.template": "Шаблон параметров ссылки",
"partners.field.subIdParam": "Параметр sub_id",
"partners.field.clickIdParam": "Параметр click_id",
    "partners.hosts.hint": "По одному хосту в строке",
    "partners.type.placeholder": "Выберите тип",
    "partners.error.required": "Заполните поле",
    "partners.error.hosts": "Эти хосты не приняты сервером",
    "partners.error.invalid": "Значение не принято сервером",
    "partners.confirm.title": "Подтвердите изменение",
    "partners.confirm.disable": "Партнёр будет отключён. Это затронет Pick, которые его используют.",
    "partners.confirm.hosts": "В список разрешённых будут добавлены хосты:",
    "partners.confirm.audit": "Действие фиксируется в журнале аудита",
    "partners.confirm.accept": "Подтвердить",
    "partners.saved": "Сохранено",
    "partners.created": "Партнёр добавлен",
    "partners.affected": "Затронуто Pick: {count}",
    "partners.conflict.hint":
      "Перезагрузите реестр и повторите правку на актуальной версии.",
  },
  en: {
    "partners.add": "Add partner",
    "partners.empty": "No partners yet",
    "partners.col.name": "Name",
    "partners.col.type": "Type",
    "partners.col.status": "Status",
    "partners.col.brand": "Brand display",
    "partners.col.hosts": "Allowed hosts",
    "partners.col.actions": "Actions",
    "partners.edit": "Edit",
    "partners.editNamed": "Edit {name}",
    "partners.type.affiliate_network": "Affiliate network",
    "partners.type.direct": "Direct",
    "partners.type.editorial": "Editorial",
    "partners.status.active": "Active",
    "partners.status.disabled": "Disabled",
    "partners.brand.allowed": "Allowed",
    "partners.brand.not_allowed": "Not allowed",
    "partners.value.unknown": "Unknown",
    "partners.hosts.none": "None",
    "partners.panel.title": "Partner details",
    "partners.panel.new": "New partner",
    "partners.field.name": "Name",
    "partners.field.type": "Type",
    "partners.field.status": "Status",
    "partners.field.brand": "Brand display",
    "partners.field.hosts": "Allowed hosts",
    "partners.field.template": "Link parameter template",
"partners.field.subIdParam": "sub_id parameter",
"partners.field.clickIdParam": "click_id parameter",
    "partners.hosts.hint": "One host per line",
    "partners.type.placeholder": "Choose a type",
    "partners.error.required": "Fill in this field",
    "partners.error.hosts": "These hosts were not accepted",
    "partners.error.invalid": "The server did not accept this value",
    "partners.confirm.title": "Confirm the change",
    "partners.confirm.disable":
      "The partner will be disabled. This affects the picks that use it.",
    "partners.confirm.hosts": "These hosts will be added to the allowlist:",
    "partners.confirm.audit": "This action is recorded in the Audit Log",
    "partners.confirm.accept": "Confirm",
    "partners.saved": "Saved",
    "partners.created": "Partner added",
    "partners.affected": "Affected picks: {count}",
    "partners.conflict.hint":
      "Reload the registry and repeat your edit on the current version.",
  },
});

export default partners;
